<template>

    <div class="c-d_content">
        <slot></slot>
    </div>

</template>


<script>

export default {

    name: 'TheDashboardContent'

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-d_content {
    border-radius: 0.25rem;
    border: 1px solid $c-border;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row wrap;
    flex-grow: 999;

    @include bp($screen-md) {
        border-left: none;
        border-right: none;
        border-radius: 0;
    }
    section {
        outline: 1px solid $c-border;
        background-color: $c-white;
        padding: 50px;

        @include bp($screen-md) {
            padding: 50px 30px;
        }
        @include bp($screen-sm) {
            padding: 20px;
        }
    }
}

</style>
